import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Domain1 from "components/Typography/Domain1.jsx";
import Domain2 from "components/Typography/Domain2.jsx";
import Domain3 from "components/Typography/Domain3.jsx";
import Domain4 from "components/Typography/Domain4.jsx";
import Domain5 from "components/Typography/Domain5.jsx";
import Domain6 from "components/Typography/Domain6.jsx";
import Domain7 from "components/Typography/Domain7.jsx";
import PDCourseCard from "components/PDCourseCard/PDCourseCard.jsx";
import MenuItem from "@material-ui/core/MenuItem";
import DomainTitle from "components/DomainTitle/DomainTitle.jsx";

import blogsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/blogsStyle.jsx";

function PDCourseListSection({ ...props }) {

  const [values, setValues] = React.useState({
    domain: "ALL",
    date: "ALL"
  });
  console.log("props", props);
  const { classes, courses, ...rest } = props;

  const renderDomainName = function(item) {
    const title = <h6 className={classes.cardCategory}>{item.domain}</h6>;
    const domainId = item.id.split("_").shift();
    console.log("domainId", domainId);
    switch (domainId) {
      case "D1":
        return <Domain1>{title}</Domain1>;
      case "D2":
        return <Domain2>{title}</Domain2>;
      case "D3":
        return <Domain3>{title}</Domain3>;
      case "D4":
        return <Domain4>{title}</Domain4>;
      case "D5":
        return <Domain5>{title}</Domain5>;
      case "D6":
        return <Domain6>{title}</Domain6>;
      case "D7":
        return <Domain7>{title}</Domain7>;
    }
  };

  const pdcoursesdata = props.courses
    .filter(item => {
      return (
        item.id.split("_").shift() === values.domain ||
        values.domain === "ALL" ||
        values.domain === ""
      );
    })
    .filter(item => {
      return (
        (values.date === "CURRENT_OFFERINGS" && item.sd !== "TBC") ||
        values.date === "ALL"
      );
    });

  let tricourses = [...pdcoursesdata];
  tricourses.sort((a, b) => {
    const asort = a.sd === "TBC" ? new Date("2999-12-31") : new Date(a.sd);
    const bsort = b.sd === "TBC" ? new Date("2999-12-31") : new Date(b.sd);
    return asort - bsort;
  });

  const pdcourses = tricourses.map(item => {
    return (
      <GridItem key={item.id} xs={12} md={6} lg={4}>
        <PDCourseCard
          id={item.id}
          domain={item.domain}
          name={item.name}
          sd={item.sd}
        />
      </GridItem>
    );
  });

  function handleChange(event) {
    setValues(oldValues => ({
      ...oldValues,
      [event.target.name]: event.target.value
    }));
  };

  return (
    <div className="cd-section" {...rest}>
      <div className={classes.blog}>
        <div className={classes.container}>
          <GridContainer
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <GridItem mdAuto>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="filter-domain">Domain</InputLabel>
                <Select
                  value={values.domain}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{
                    name: "domain",
                    id: "filter-domain"
                  }}
                >
                  <MenuItem value={"ALL"}>All</MenuItem>
                  <MenuItem value={"D1"}><DomainTitle domainId="D1" domainName="Design Learning and Teaching" /></MenuItem>
                  <MenuItem value={"D2"}><DomainTitle domainId="D2" domainName="Facilitating and Delivering Learning and Teaching" /></MenuItem>
                  <MenuItem value={"D3"}><DomainTitle domainId="D3" domainName="Transforming Assessment" /></MenuItem>
                  <MenuItem value={"D4"}><DomainTitle domainId="D4" domainName="Optimising Digital Technologies for Learning and Teaching" /></MenuItem>
                  <MenuItem value={"D5"}><DomainTitle domainId="D5" domainName="Transforming the Broader Student Experience" /></MenuItem>
                  <MenuItem value={"D6"}><DomainTitle domainId="D6" domainName="Industry and Academic Collaboration & Currency" /></MenuItem>
                  <MenuItem value={"D7"}><DomainTitle domainId="D7" domainName="Innovating in Learning and Teaching" /></MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="filter-date">Date</InputLabel>
                <Select
                  value={values.date}
                  onChange={handleChange}
                  inputProps={{
                    name: "date",
                    id: "filter-date"
                  }}
                >
                  <MenuItem value={"ALL"}>All</MenuItem>
                  <MenuItem value={"CURRENT_OFFERINGS"}>
                    Current Offerings
                  </MenuItem>
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          {pdcourses && <GridContainer>{pdcourses}</GridContainer>}
          {pdcourses.length === 0 &&
            (values.domain !== "ALL" || values.date !== "ALL") && (
              <GridContainer>
                <GridItem>
                  <h4>No PD found. Change your filter to find PD.</h4>
                </GridItem>
                {pdcourses}
              </GridContainer>
          )}
        </div>
      </div>
    </div>
  );
}

export default withStyles(blogsStyle)(PDCourseListSection);
